import { MODULE as PARENT } from '../constants'

export const KEY = 'car-catalog'
export const MODULE = [...[PARENT], KEY]

export const FETCH_BRANDS = `${MODULE.join('/')}-fetch-brands`
export const CLEAR_BRANDS = `${MODULE.join('/')}-clear-brands`
export const FETCH_MODELS = `${MODULE.join('/')}-fetch-models`
export const CLEAR_MODELS = `${MODULE.join('/')}-clear-models`
